export const genresList = [
  { id: 1, name: 'Action' },
  { id: 2, name: 'Autobiography' },
  { id: 3, name: 'Adventure' },
  { id: 4, name: 'Biography' },
  { id: 5, name: 'Drama' },
  { id: 6, name: 'MindAndBody' },
  { id: 7, name: 'EBooks' },
  { id: 8, name: 'Educational' },
  { id: 9, name: 'Encyclopedia' },
  { id: 10, name: 'EpicFantasy' },
  { id: 11, name: 'Erotic' },
  { id: 12, name: 'Fantasy' },
  { id: 13, name: 'Philosophy' },
  { id: 14, name: 'Horror' },
  { id: 15, name: 'InteractiveBook' },
  { id: 16, name: 'InternetAndComputers' },
  { id: 17, name: 'History' },
  { id: 18, name: 'Historical' },
  { id: 19, name: 'HistoricalThriller' },
  { id: 20, name: 'Classics' },
  { id: 21, name: 'ChildrensBooks' },
  { id: 22, name: 'Comedy' },
  { id: 23, name: 'ComicFantasy' },
  { id: 24, name: 'Crime' },
  { id: 25, name: 'Cookbooks' },
  { id: 26, name: 'Romance' },
  { id: 27, name: 'MangaAndComics' },
  { id: 28, name: 'MarketingAndManagement' },
  { id: 29, name: 'Mythologies' },
  { id: 30, name: 'ScienceFiction' },
  { id: 31, name: 'Poetry' },
  { id: 32, name: 'PopularScience' },
  { id: 33, name: 'PopularPsychology' },
  { id: 34, name: 'ShortStories' },
  { id: 35, name: 'Psychology' },
  { id: 36, name: 'Journalism' },
  { id: 37, name: 'Travelogues' },
  { id: 38, name: 'Sports' },
  { id: 39, name: 'ConspiracyTheories' },
  { id: 40, name: 'Teen' },
  { id: 41, name: 'Thrillers' },
  { id: 42, name: 'Art' },
];

export const getGenre = (id: any) => {
  return genresList.find((genre) => genre.id === id);
};
